import { Row } from "react-bootstrap";
import styled from "styled-components";

export const Container = styled.div`
  margin-top: 1.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  padding: 0;
  margin: 0;
`;

export const DadosContainer = styled(Row)`
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  padding: 20px;
`;

export const ContainerExplicacao = styled.div`
  padding: 16px 0;
`;

export const ContainerEditar = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TituloEditar = styled.div`
  color: ${({ theme }) => theme.colors.neutral.neutral70};
`;
